import React from "react";
import axios from "axios";
import "./especialistasNuevos.css";
import PlanillaForm from "./planillaForm";

const URL =
  "https://institutobilinguelasnaciones.com/terapias/backend/especialistasNuevos.php";
const PDF =
  "https://institutobilinguelasnaciones.com/terapias/fpdf/reportes/reportePlanillaEspecialista.php";

function post(boton, extra) {
  const data = new FormData();
  data.append("boton", boton);
  Object.keys(extra || {}).forEach(function (clave) {
    data.append(clave, extra[clave]);
  });
  return axios.post(URL, data, { headers: { "Content-Type": "text/html" } });
}

function vacio() {
  return {
    id: "",
    nombre_completo: "",
    apellido: "",
    cedula: "",
    pasaporte: "",
    fecha_nacimiento: "",
    edad: "",
    nacionalidad: "",
    pais_residencia: "",
    telefono: "",
    correo: "",
    provincia: "",
    ciudad: "",
    direccion: "",
    profesion: "",
    especialidad: "",
    anos_experiencia: "",
    idoneidad_numero: "",
    pais_habilitado: "",
    resumen_profesional: "",
    declaracion_aceptada: 0,
    nombre_declaracion: "",
    fecha_declaracion: "",
    firma: "mantener",
    tieneFoto: false,
    tieneFirma: false,
    formacion: [{ titulo: "", institucion: "", pais: "", anio: "" }],
    certificaciones: [{ nombre: "", institucion: "", pais: "", anio: "" }],
    experiencia: [
      { cargo: "", empresa: "", pais: "", fecha_desde: "", fecha_hasta: "" },
    ],
    pago: {
      transferencia: 0,
      yappy: 0,
      western: 0,
      cheque: 0,
      efectivo: 0,
      otro: 0,
      otro_descripcion: "",
    },
    transferencia: {
      titular: "",
      banco: "",
      tipo_cuenta: "ahorros",
      numero_cuenta: "",
      pais: "",
    },
    yappy: { nombre_titular: "", numero: "" },
    western: {
      nombre_beneficiario: "",
      cedula_pasaporte: "",
      pais: "",
      ciudad: "",
      telefono: "",
    },
    otro_pago: { metodo: "", datos: "" },
    documentos: [],
  };
}

function fechaInput(valor) {
  if (!valor) return "";
  return String(valor).substring(0, 10);
}

export default function EspecialistasNuevos(props) {
  const [lista, setLista] = React.useState([]);
  const [planilla, setPlanilla] = React.useState(null);
  const [mensaje, setMensaje] = React.useState("");
  const [aviso, setAviso] = React.useState("");
  const [cargando, setCargando] = React.useState(false);
  const [paso, setPaso] = React.useState(0);
  const [repetirFirma, setRepetirFirma] = React.useState(false);
  const [elegido, setElegido] = React.useState("");
  const [verTodos, setVerTodos] = React.useState(false);

  const cargarLista = React.useCallback(function () {
    setCargando(true);
    setMensaje("");
    post("listar", verTodos ? { todos: "1" } : {})
      .then(function (res) {
        if (res.data.variable1) {
          setLista(res.data.variable2 || []);
        } else {
          setMensaje(res.data.variable2 || "No se pudo consultar.");
        }
      })
      .catch(function () {
        setMensaje("No se pudo consultar los especialistas.");
      })
      .finally(function () {
        setCargando(false);
      });
  }, [verTodos]);

  React.useEffect(function () {
    cargarLista();
  }, [cargarLista]);

  function abrir(id) {
    setElegido(id);
    setMensaje("");
    setAviso("");
    setCargando(true);
    post("ver", { id: id })
      .then(function (res) {
        if (!res.data.variable1) {
          setMensaje(res.data.variable2 || "No se pudo abrir la planilla.");
          return;
        }
        const datos = res.data.variable2;
        const persona = datos.especialista || {};
        const form = vacio();
        form.id = persona.id;
        form.nombre_completo = persona.nombre_completo || "";
        form.apellido = persona.apellido || "";
        form.cedula = persona.cedula || "";
        form.pasaporte = persona.pasaporte || "";
        form.fecha_nacimiento = fechaInput(persona.fecha_nacimiento);
        form.edad = persona.edad || "";
        form.nacionalidad = persona.nacionalidad || "";
        form.pais_residencia = persona.pais_residencia || "";
        form.telefono = persona.telefono || "";
        form.correo = persona.correo || "";
        form.provincia = persona.provincia || "";
        form.ciudad = persona.ciudad || "";
        form.direccion = persona.direccion || "";
        form.profesion = persona.profesion || "";
        form.especialidad = persona.especialidad || "";
        form.anos_experiencia =
          persona.anos_experiencia === null || persona.anos_experiencia === undefined
            ? ""
            : String(persona.anos_experiencia);
        form.idoneidad_numero = persona.idoneidad_numero || "";
        form.pais_habilitado = persona.pais_habilitado || "";
        form.resumen_profesional = persona.resumen_profesional || "";
        form.declaracion_aceptada = Number(persona.declaracion_aceptada) === 1 ? 1 : 0;
        form.nombre_declaracion = persona.nombre_declaracion || "";
        form.fecha_declaracion = fechaInput(persona.fecha_declaracion);
        form.tieneFoto = !!persona.foto;
        form.tieneFirma = !!persona.firma;
        form.firma = "mantener";
        form.formacion =
          datos.formacion && datos.formacion.length
            ? datos.formacion
            : form.formacion;
        form.certificaciones =
          datos.certificaciones && datos.certificaciones.length
            ? datos.certificaciones
            : form.certificaciones;
        form.experiencia =
          datos.experiencia && datos.experiencia.length
            ? datos.experiencia.map(function (fila) {
                return {
                  cargo: fila.cargo || "",
                  empresa: fila.empresa || "",
                  pais: fila.pais || "",
                  fecha_desde: fechaInput(fila.fecha_desde),
                  fecha_hasta: fechaInput(fila.fecha_hasta),
                };
              })
            : form.experiencia;
        form.pago = Object.assign(form.pago, datos.pago || {});
        form.transferencia = Object.assign(form.transferencia, datos.transferencia || {});
        form.yappy = Object.assign(form.yappy, datos.yappy || {});
        form.western = Object.assign(form.western, datos.western || {});
        form.otro_pago = Object.assign(form.otro_pago, datos.otro_pago || {});
        form.documentos = datos.documentos || [];
        setPaso(0);
        setRepetirFirma(false);
        setPlanilla(form);
      })
      .catch(function () {
        setMensaje("No se pudo abrir la planilla.");
      })
      .finally(function () {
        setCargando(false);
      });
  }

  function cambiar(campo, valor) {
    setPlanilla(function (previo) {
      return Object.assign({}, previo, { [campo]: valor });
    });
  }

  function cambiarGrupo(grupo, campo, valor) {
    setPlanilla(function (previo) {
      const copia = Object.assign({}, previo);
      copia[grupo] = Object.assign({}, previo[grupo], { [campo]: valor });
      return copia;
    });
  }

  function cambiarFila(listaNombre, indice, campo, valor) {
    setPlanilla(function (previo) {
      const filas = previo[listaNombre].slice();
      filas[indice] = Object.assign({}, filas[indice], { [campo]: valor });
      return Object.assign({}, previo, { [listaNombre]: filas });
    });
  }

  function agregarFila(listaNombre, muestra) {
    setPlanilla(function (previo) {
      return Object.assign({}, previo, {
        [listaNombre]: previo[listaNombre].concat([muestra]),
      });
    });
  }

  function quitarFila(listaNombre, indice, muestra) {
    setPlanilla(function (previo) {
      const filas = previo[listaNombre].filter(function (_, i) {
        return i !== indice;
      });
      return Object.assign({}, previo, {
        [listaNombre]: filas.length ? filas : [muestra],
      });
    });
  }

  function guardar() {
    setMensaje("");
    setAviso("");
    setCargando(true);
    const envio = Object.assign({}, planilla);
    delete envio.documentos;
    delete envio.tieneFoto;
    delete envio.tieneFirma;
    delete envio.edad;
    post("guardar", { planilla: JSON.stringify(envio) })
      .then(function (res) {
        if (res.data.variable1) {
          setAviso("Planilla actualizada.");
          abrir(planilla.id);
        } else {
          setMensaje(res.data.variable2 || "No se pudo guardar.");
          setCargando(false);
        }
      })
      .catch(function () {
        setMensaje("No se pudo guardar la planilla.");
        setCargando(false);
      });
  }

  function subir(tipo, archivo) {
    if (!archivo || !planilla) return;
    setMensaje("");
    setAviso("");
    const data = new FormData();
    data.append("boton", "subir");
    data.append("id", planilla.id);
    data.append("tipo", tipo);
    data.append("archivo", archivo);
    setCargando(true);
    axios
      .post(URL, data, { headers: { "Content-Type": "text/html" } })
      .then(function (res) {
        if (res.data.variable1) {
          setAviso("Archivo actualizado.");
          abrir(planilla.id);
        } else {
          setMensaje(res.data.variable2 || "No se pudo adjuntar.");
          setCargando(false);
        }
      })
      .catch(function () {
        setMensaje("No se pudo adjuntar el archivo.");
        setCargando(false);
      });
  }

  function archivoUrl(tipo) {
    return URL + "?boton=archivo&id=" + planilla.id + "&tipo=" + tipo;
  }

  function preaprobar() {
    const item = lista.find(function (fila) {
      return String(fila.variable1) === String(elegido);
    });
    if (!item) {
      setMensaje("Seleccione un especialista de la lista.");
      setAviso("");
      return;
    }
    if (!window.confirm("¿Preaprobar a " + item.variable2 + " en la nómina de la Fundación? Se guardan los datos de la primera pantalla de personal. Si no tiene cédula se usa el pasaporte.")) {
      return;
    }
    setCargando(true);
    setMensaje("");
    setAviso("");
    post("preaprobar", { id: elegido })
      .then(function (res) {
        if (res.data.variable1) {
          setElegido("");
          setAviso(res.data.variable2 || "Se registró en la nómina de la Fundación.");
          cargarLista();
        } else {
          setMensaje(res.data.variable2 || "No se pudo preaprobar.");
          setCargando(false);
        }
      })
      .catch(function () {
        setMensaje("No se pudo preaprobar el especialista.");
        setCargando(false);
      });
  }

  function eliminarEspecialista(id, nombre) {
    const quien = nombre || "este especialista";
    if (!window.confirm("¿Eliminar a " + quien + " de miperfil? Se borra la planilla, los documentos y los datos de pago. No se puede deshacer.")) {
      return;
    }
    setCargando(true);
    setMensaje("");
    setAviso("");
    post("eliminar", { id: id })
      .then(function (res) {
        if (res.data.variable1) {
          setPlanilla(null);
          setPaso(0);
          setAviso("Especialista eliminado de miperfil.");
          cargarLista();
        } else {
          setMensaje(res.data.variable2 || "No se pudo eliminar el especialista.");
          setCargando(false);
        }
      })
      .catch(function () {
        setMensaje("No se pudo eliminar el especialista.");
        setCargando(false);
      });
  }

  if (!planilla) {
    return (
      <div className="esp-panel">
        <div className="esp-barra">
          <h2>Especialistas Nuevos</h2>
          <button type="button" className="esp-x" onClick={props.cerrar}>
            ×
          </button>
        </div>
        <div className="esp-cuerpo">
          {mensaje ? <p className="esp-nota">{mensaje}</p> : null}
          {aviso ? <p className="esp-ok">{aviso}</p> : null}
          {cargando ? <p>Procesando...</p> : null}
          <table className="esp-tabla">
            <thead>
              <tr>
                <th></th>
                <th>Nombre</th>
                <th>Edad</th>
                <th>Especialidad</th>
                <th>Años de experiencia</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              {lista.map(function (item) {
                return (
                  <tr
                    key={item.variable1}
                    className={String(elegido) === String(item.variable1) ? "elegida" : ""}
                    onClick={function () { abrir(item.variable1); }}
                  >
                    <td onClick={function (e) { e.stopPropagation(); }}>
                      <input
                        type="radio"
                        name="esp-elegido"
                        checked={String(elegido) === String(item.variable1)}
                        onChange={function () { setElegido(item.variable1); }}
                      />
                    </td>
                    <td>{item.variable2}</td>
                    <td>{item.variable3}</td>
                    <td>{item.variable4}</td>
                    <td>{item.variable5}</td>
                    <td>
                      <button
                        type="button"
                        className="esp-eliminar"
                        onClick={function (e) {
                          e.stopPropagation();
                          eliminarEspecialista(item.variable1, item.variable2);
                        }}
                      >
                        Eliminar
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
          <div className="esp-acciones">
            <button type="button" className="boton" onClick={preaprobar} disabled={cargando}>
              Pre aprobar
            </button>
            <button
              type="button"
              className="boton"
              onClick={function () { setVerTodos(function (actual) { return !actual; }); setElegido(""); }}
              disabled={cargando}
            >
              {verTodos ? "Ver pendientes" : "Consultar todos los especialistas"}
            </button>
            <button type="button" className="boton" onClick={props.cerrar}>
              Salir
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <PlanillaForm
      planilla={planilla}
      paso={paso}
      setPaso={setPaso}
      mensaje={mensaje}
      aviso={aviso}
      cargando={cargando}
      repetirFirma={repetirFirma}
      setRepetirFirma={setRepetirFirma}
      cambiar={cambiar}
      cambiarGrupo={cambiarGrupo}
      cambiarFila={cambiarFila}
      agregarFila={agregarFila}
      quitarFila={quitarFila}
      guardar={guardar}
      subir={subir}
      archivoUrl={archivoUrl}
      imprimir={function () { window.open(PDF + "?id=" + planilla.id, "_blank"); }}
      eliminar={function () { eliminarEspecialista(planilla.id, planilla.nombre_completo); }}
      volver={function () { setPlanilla(null); setAviso(""); setMensaje(""); setPaso(0); cargarLista(); }}
    />
  );
}
